import { colors } from '@chegg-ui/theme';
export var parseTaxInfoContent = function parseTaxInfoContent(text, price, basePrice) {
  var formattedPrice = basePrice ? "<span style=\"color: ".concat(colors.cheggOrange, "\">").concat(price, "</span>") : price;
  return text.split('${price}').join(formattedPrice).split('${basePrice}').join(basePrice);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/Tax/helper.js
// module id = 4016
// module chunks = 11